'use client'

import React from 'react'
import { I18nProvider as LingUiI18nProvider } from '@lingui/react'
import { i18n } from '@lingui/core'

export const I18nProvider: React.FC<{
  children: React.ReactNode
  landing?: boolean
  common?: boolean
  blog?: boolean
}> = ({ children, landing, common, blog }) => {
  const [loaded, setLoaded] = React.useState(false)
  const loadLocale = React.useCallback(async () => {
    const locales = await Promise.all([
      landing ? import('../../locales/en-gb/landing.po') : null,
      common ? import('../../locales/en-gb/common.po') : null,
      blog ? import('../../locales/en-gb/blog.po') : null,
    ])
    const messages = locales.reduce(
      (messages, locale) => ({ ...messages, ...locale?.messages }),
      {} as Record<string, string>,
    )
    i18n.loadAndActivate({ locale: 'en-gb', messages })
    setLoaded(true)
  }, [])
  React.useLayoutEffect(() => {
    loadLocale()
  }, [loadLocale])

  if (!loaded) {
    return null
  }
  return <LingUiI18nProvider i18n={i18n}>{children}</LingUiI18nProvider>
}
